import { cloneDeep } from "lodash";
import { OrderType } from "../../../utils/homologar/search/utils/constants";

export const defaultMedicine = { text: "" };

const defaultOrder = { items: [], clarifications: "", template: null, procedureType: null };

/**
 * Returns the initial orders array.
 * v2 + any non-manual tab (Prácticas, etc.): no cards — created on first practice selected.
 * v2 + Otros (manual): one empty card to allow free text.
 * v1: always one empty card.
 */
export const getDefaultOrders = (isV2 = false, orderType = null) => {
  if (isV2 && orderType !== OrderType.MANUAL) return [];
  return cloneDeep([defaultOrder]);
};

export const MAX_ORDERS = 10;
export const NOMENCLATURE_ORDER_CLARIFICATIONS_LABEL =
  "Detalles o indicaciones";
